// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2e5xc","icon":"SortAdornment_icon__oJl1W","up":"SortAdornment_up__3sMeG","down":"SortAdornment_down__1yGtT","active":"SortAdornment_active__3u6q8"};